import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { TaskDocument } from "../../core/model/task-document";
import { TaskDocumentService } from "../../core/service/task-document.service";

@Component({
  selector: "app-add-task-document",
  templateUrl: "./add-task-document.component.html",
  styleUrls: ["./add-task-document.component.scss"],
})
export class AddTaskDocumentComponent implements OnInit {
  @Input() taskworkflowId;

  taskDocument: TaskDocument = new TaskDocument();

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _taskDocumentService: TaskDocumentService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      obligatoire: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
      description: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this.taskDocument.taskWorkflowByProfileId = this.taskworkflowId;
    this._taskDocumentService
      .add(this.taskDocument)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
